<div class="login-card d-flex flex-column mt-5" *ngIf="!isOtpValid">
    <span class="satsang-text">Fill details below to Log In</span>
    <div class="d-flex flex-column login-field-gap position-relative">
        <input type="tel" class="login-field" placeholder="Enter OTP" [(ngModel)]="otp" maxlength="6" />
    </div>
    <button type="submit" class="btn-signup w-100" (click)="submit()">
        Enter your otp to proceed
    </button>
</div>
<div class="public-view" *ngIf="isOtpValid">
    <div class="mobile-card-view">
        <div class="card-wrapper">
            <div class="card-view" *ngFor="let item of mobileNibedonInProgress" (click)="openBottomSheetSlider(item)">

                <div class="card-row-view">
                    <span class="label-view">Date & Time</span>
                    <span class="value-view">{{ item.createdTimeStamp | date:"d MMM yy | hh:mm a"}}</span>
                </div>

                <div class="card-row-view">
                    <span class="label-view">Nibedon ID</span>
                    <span class="value-view" cdkCopyToClipboard="{{item.nivedanCode}}" matTooltip="{{toolTip}}"
                        (click)="onCopied($event)">{{ item.nivedanCode }}</span>
                </div>

                <div class="card-row-view">
                    <span class="label-view">Name</span>
                    <span class="value-view">{{ item.devotee.firstName }} {{ item.devotee.lastName
                        }}</span>
                </div>

                <div class="card-row-view">
                    <span class="label-view">Phone Number</span>
                    <span class="value-view">{{ item.phoneNumber }}</span>
                </div>

                <div class="card-row-view">
                    <span class="label-view">Category</span>
                    <span class="value-view">{{getCategoryDescription(item.categoryCode)}}</span>
                </div>

                <div class="card-row-view">
                    <span class="label-view">Status</span>
                    <span class="status-text" [ngClass]="dynamicStatusColor(item.status)"
                        style="background-color: transparent; word-break: break-all;">{{
                        formatStatus(item.status) }}

                    </span>
                </div>
                <div class="div" *ngIf="mobileNibedonInProgress.length === 0">
                    <span style="color: #ffffff;">No Data Found.</span>
                </div>
            </div>
        </div>

    </div>
</div>